import react from "react";
import "./Profile.css";
import Bar from "./Bar";

function Profile() {
  return (
    <div className="profile">
      <h2>프로필</h2>
      <div className="image">
        <div className="small-title">여기</div>
        <div className="small-title">잠깐</div>
        <div className="small-title">밥팟</div>
      </div>
      <hr />
      <div className="information">
        <div className="inform">이름: </div>
        <div className="inform">대학교: </div>
        <div className="inform">지역: </div>
        <div className="inform">백신접종여부: </div>
        <div className="inform">전화번호: </div>
        <div className="inform">오늘의 밥약: </div>
        <div className="inform">등록된 밥약 D-DAY</div>
      </div>
      <div className="nav-bar4">
        <Bar></Bar>
      </div>
    </div>
  );
}

export default Profile;
